import React from "react";
import { Input, Radio, Button, Row, Col } from "antd";
import { observer } from "mobx-react";
import { isFatherToChild } from "../../utils/";

import { removeEmojis } from "../../utils/index";
let isImeOn = false; // IME 入力中フラグ
let isMessageTooLong = false; // this.message の文字数制限を超えているか

const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "50px",
  lineHeight: "30px"
};

class CustomMessage extends React.Component {
  constructor() {
    super();
    this.state = {
      type: "", // "papa" | "mama"
      font: "",
      messages: ["", "", "", "", ""],
      saved: false,
      fontListMap: {
        papa: [ // パパ用
          { type: 'malecharacter' },
          { type: 'banana' },
          { type: 'hui' },
          { type: 'darts' },
          { type: 'kacho' },
          { type: 'genshin' },
        ],
        mama: [ // ママ用
          { type: 'anzu' },
          { type: 'uzura' },
          { type: 'hui' },
          { type: 'darts' },
          { type: 'beautiful' },
          { type: 'genshin' },
        ],
      },
      fontList: []
    };
  }

  save = e => {
    const m = this.state.messages;
    this.props.book.parentToChild.changePersonalFont(this.state.font);
    for (let i = 0; i < m.length; i++)
      this.props.book.parentToChild.setPersonalMessage(i, m[i]);
    this.setState({ saved: true });
    this.props.order.nextStep();
  }
  handleRadioChange = e =>
    this.setState({ font: e.target.value, saved: false });
  handleTextChange = e => {
    let messages = this.state.messages;
    let message = e.target.value;
    if(!isImeOn) {
      message = removeEmojis(message); // 絵文字があれば除去
    }
    messages[e.target.id] = message;

    // 21文字を超えているか
    isMessageTooLong = messages.some(item => item.length > 21);
    // console.log({isMessageTooLong});
    this.setState({ messages, saved: false });
  };
  // 入力フォームの onChange イベントを IME ON のときに無視する
  // https://maku.blog/p/cv6fpx7/
  handleTextCompositionStart = () => {
    // console.log('handleTextCompositionStart');
    isImeOn = true; // IME 入力中フラグを ON
  }
  handleTextCompositionEnd = e => {
    // console.log('handleTextCompositionEnd');
    isImeOn = false; // IME 入力中フラグを OFF
    this.handleTextChange(e);
  }

  componentWillMount() {
    if (this.props.book) {
      const { personalMessage } = this.props.book.parentToChild;
      let messages = ["", "", "", "", "", "", "", ""];
      let type = "";
      let font = "";
      let fontList = [];

      // デフォルトの設定
      if (isFatherToChild(this.props.book)) {
        type = "papa";
        font = "malecharacter";
        fontList = this.state.fontListMap.papa;
      } else {
        type = "mama";
        font = "anzu";
        fontList = this.state.fontListMap.mama;
      }

      for (let i = 0; i < messages.length; i++) messages[i] = personalMessage[i];
      this.setState({
        type,
        font,
        messages,
        fontList
      });
    }
  }

  render() {
    return (
      <div className="custom-message">
        <div className="step pd-15">
          <div className="step-title">{"STEP 1"}</div>
          <div className="step-txt">
            {"未来のお子様に向けたメッセージを自由に記入してください。"}
            <br />
            {"※ 最大8行（1行の最大文字数は全角21文字）まで入力可能"}
            <br />
            {"※ １行毎に完結する文章のほうが美しい仕上がりになります"}
            <br />
            {"※ 絵文字や環境依存文字等はご利用いただけません"}
          </div>
        </div>

        {this.state.messages.map((v, i) => (
          <div className="message-line pd-r15 pd-l15" key={i} data-warning={v.length > 21}>
            <Row>
              <Col span={3}>
                <div className="txt-center">
                  <strong>{`${i + 1}行目`}</strong>
                  <br />
                  <span className="counter">(<span>{`${v.length}`}</span>/21)</span>
                </div>
              </Col>
              <Col span={21}>
                <Input
                  key={i}
                  id={i}
                  onChange={this.handleTextChange}
                  onCompositionStart={this.handleTextCompositionStart}
                  onCompositionEnd={this.handleTextCompositionEnd}
                  value={v}
                  size="large"
                />
              </Col>
            </Row>
          </div>
        ))}
        <div className="step pd-15 step-2">
          <div className="step-title">{"STEP 2"}</div>
          <div className="step-txt">
            {"メッセージの表示フォントを選んでください。"}
          </div>
          <br />
          <RadioGroup
            className="font-list"
            defaultValue={`${this.state.font}`}
            onChange={this.handleRadioChange}
            value={this.state.font}
          >
            { this.state.fontList.map(item => (
              <Radio
                key={item.type}
                style={radioStyle}
                value={item.type}
                size="large"
              >
                <img
                  className="logo2"
                  src={require(`../../imgs/parent_to_child/font_${item.type}.png`)}
                  alt=""
                />
              </Radio>
            ))}
          </RadioGroup>
          <br />
          <br />
          <div className="btn-wrap">
            <button
              disabled={this.state.messages.join("") === "" || isMessageTooLong}
              onClick={this.save}
              className="btn product-btn"
            >
              {"保存して次へ"}
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(CustomMessage);



// WEBPACK FOOTER //
// ./src/components/steps/CustomMessageParentToChild.js